export default {

  createPolygon(data) {
    return env.API.post('/user/field/add', data);
  },
  getFields() {
    return env.API.get('/user/field/allFieldsForUser');
  },
  getFarms() {
    return env.API.get('/user/field/allFarmsForUser');
  },
  deleteField(id) {
     return env.API.post('/user/field/delete', {id : id});
  },
  deleteFarm(id) {
    return env.API.delete(`/farms/${id}`);
  },
  getFieldsAndFarms() {
    return env.API.get('/user/field/all');
  },
  getInfoForDashboard(farmId, fieldId, type, take) {
    return env.API.post( '/user/dashboard/recent', { farmId : farmId, fieldId : fieldId, type : type, take : 5 } );
  },


}
